import angular from 'angular'
import template from './template.html'
import './style.scss'

angular.module('nominas.cargacontpaq')
  .component('nominasCargacontpaqImportarTabla', {
    template: template,
    controller: NominasCargacontpaqImportarTablaComponent,
    bindings: {
      encabezados: '<',
      filas: '<',
      onChange: '&',
      onDelete: '&',
    },
  });

function NominasCargacontpaqImportarTablaComponent($filter, $http) {
  let $ctrl = this,
    filterBy = $filter('filter');

  $ctrl.$onChanges = $onChanges;
  $ctrl.$onInit = $onInit;
  $ctrl.actualizar = actualizar;
  $ctrl.borrar = borrar;
  $ctrl.data = {};
  $ctrl.editando = null;
  $ctrl.editar = editar;
  $ctrl.filtrar = filtrar;
  $ctrl.obtenerConceptos = obtenerConceptos;

  function $onChanges(changes) {
    if (changes.filas) {
      procesarFilas();
    }

    if (changes.encabezados) {
      procesarEncabezados();
    }
  }

  function $onInit() {
    obtenerConceptos();
  }

  function obtenerConceptos() {
    $ctrl.conceptos = undefined;

    actualizar();

    $ctrl.promise = $http.get('api/nominas/carga-contpaqi/conceptos', {
        schema: {id: 'number', id_tipo_valor: 'number', identificador: 'boolean'},
      })
      .then(function (response) {
        $ctrl.conceptos = response.data;

        procesarEncabezados();
      });
  }

  function actualizar(data) {
    $ctrl.onChange({$event: {data: data}});
  }

  function borrar() {
    $ctrl.onDelete();
  }

  function editar(concepto, data) {
    if ($ctrl.editando === null) {
      $ctrl.editando = concepto;

      return;
    }

    if (data) {
      obtenerConceptos();
    }

    $ctrl.editando = null;
  }

  function filtrar() {
    $ctrl.resultados = filterBy($ctrl.data.filas, $ctrl.filtro);
  }

  function procesarEncabezados() {
    if (!$ctrl.conceptos)
      return;

    $ctrl.data.encabezados = $ctrl.encabezados
      .map(function (encabezado) {
        let concepto;

        if (encabezado) {
          concepto = $ctrl.conceptos.find(function (item) {
            return item.descripcion.toUpperCase() === encabezado.toUpperCase();
          });
        }

        return concepto || {
          id: undefined,
          id_tipo_valor: 1,
          descripcion: encabezado,
          indice: null,
          script: '',
        };
      });

    $ctrl.data.indices = $ctrl.data.encabezados
      .reduce(function (indices, encabezado) {
        if (encabezado.indice)
          indices.push(encabezado);

        return indices;
      }, []);

    $ctrl.data.identificador = $ctrl.data.encabezados
      .findIndex(function (encabezado) {
        return encabezado.identificador;
      });

    procesarFilas();
  }

  function procesarFilas() {
    if (!$ctrl.data.encabezados)
      return;

    $ctrl.totales = $ctrl.data.encabezados
      .map(function (item) {
        return item.id_tipo_valor === 2 ? 0 : null;
      });

    $ctrl.data.filas = $ctrl.filas
      .map(function (fila) {
        return fila.map(function (celda, i) {
          let config = $ctrl.data.encabezados[i],
            valor = procesarCelda(config && config.id_tipo_valor, celda);

          if (config && config.id_tipo_valor === 2)
            $ctrl.totales[i] += valor;

          return valor;
        });
      });

    filtrar();

    actualizar($ctrl.data);
  }

  function procesarCelda(tipo, valor) {
    valor = String(valor);

    switch (tipo) {
      case 2: // Decimal (2)
        return Number(parseFloat(valor.replace(/[^\d\.\-]/g, '')).toFixed(2)) || 0;
      case 3: // Entero
        return parseInt(valor.replace(/[^\d\.\-]/g, '')) || 0;
      default: // Texto
        return valor.trim();
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cargacontpaq/components/importar/tabla/component.js